import React from 'react';
import PropTypes from 'prop-types';
import AccountsStore from '../../stores/AccountsStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import Select from 'react-select-box';
import _ from 'lodash';
import moment from 'moment';
import SvgIcon from '../common/SvgIcon';
import DigitalStatementsStore from '../../stores/DigitalStatementsStore';
import StatementsPreferencesActionCreator from '../../actions/StatementsPreferencesActionCreator';
import { isCB, isYB, isVMBusiness } from '../../utils/BrandUtils';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const monthStartDay = 1;
let _monthsList = [];

const monthsToDisplay = 24;

class DigitalStatementsHeader extends React.Component {
  constructor(props) {
    super(props);
    this.onMonthChange = this.onMonthChange.bind(this);
    this.monthNumber = this.monthNumber.bind(this);
    this.modalClick = this.modalClick.bind(this);
    this.backToTop = this.backToTop.bind(this);
    this.isCBYB = this.isCBYB.bind(this);
    this.state = {
      selectedMonth: 0,
      navigationUrl: this.props.navigationUrl,
    };
  }
  onMonthChange(e) {
    this.setState({ selectedMonth: e }, () => {
      this.props.getStatementsForSelectedMonth(this.monthNumber());
    });
  }
  backClick() {
    // FinancialStoriesActionCreator.handleUpdateFSTileClick();
    InternetBankingActions.navigateToWebTask(
      DigitalStatementsStore.getNavigationUrlName()
    );
  }
  backToTop() {
    this.refs.donBtn.focus();
  }
  dropDownMonthCalculation() {
    _monthsList = [];
    let monthNameCalculation;
    if (Number(monthStartDay) === Number(moment().format('DD'))) {
      for (let i = 0; i < monthsToDisplay - 1; i++) {
        const date = moment().subtract(i + 1, 'months');
        monthNameCalculation = Number(date.format('MM')) - 1;
        if (i === 0) {
          _monthsList.push(<option value={i}>last month</option>);
        } else {
          _monthsList.push(
            <option value={i}>{`${_.nth(
              monthNames,
              monthNameCalculation
            )} ${date.format('YYYY')}`}</option>
          );
        }
      }
    } else {
      for (let i = 0; i < monthsToDisplay; i++) {
        const date = moment().subtract(i, 'months');
        monthNameCalculation = Number(date.format('MM')) - 1;
        if (i === 0) {
          _monthsList.push(<option value={i}>this month</option>);
        } else if (i === 1) {
          _monthsList.push(<option value={i}>last month</option>);
        } else {
          _monthsList.push(
            <option value={i}>{`${_.nth(
              monthNames,
              monthNameCalculation
            )} ${date.format('YYYY')}`}</option>
          );
        }
      }
    }
    return _monthsList;
  }
  goToStatementPreferences() {
    // FinancialStoriesActionCreator.getStatementPreference();
    StatementsPreferencesActionCreator.setBackPageReference(
      'WEB-DIGITAL-STATEMENTS'
    );
    InternetBankingActions.navigateToWebTask('WEB-STATEMENTS-PREFERENCES');
  }
  isCBYB() {
    return isCB() || isYB() || isVMBusiness();
  }
  modalClick() {
    this.props.helpModal(true);
  }
  monthNumber() {
    let monthNumber;
    if (Number(monthStartDay) === Number(moment().format('DD'))) {
      monthNumber = Number(this.state.selectedMonth) + 1;
    } else {
      monthNumber = this.state.selectedMonth;
    }
    return monthNumber;
  }
  render() {
    let interestRateMessage;
    let interestRate = null;
    const account = AccountsStore.getAccountDetail(this.props.accountId);
    if (account.type === 'savings') {
      if (!account.accountDetails || account.accountDetails.error) {
        interestRate = '';
        interestRateMessage =
          '<small>Sorry savings interest rate is unavailable right now. Please try again later.</small>';
      } else if (account.accountDetails.interest_rate) {
        interestRate = account.accountDetails.interest_rate;
        interestRateMessage = `Savings interest rate ${interestRate}% AER (Annual Equivalent Rate).`;
        interestRateMessage = `${interestRateMessage} </br><small>The Annual Equivalent Rate illustrates what the interest rate would be if interest was paid and compounded once each year.</small>`;
      }
    }
    return (
      <div className="fc-main-wrapper digital-statement">
        <div className="row statement-header">
          <div className="col-sm-5 col-xs-5">
            <button
              className="page-back white"
              ref="donBtn"
              onClick={this.backClick}
            >
              <span className="icon icon-page-back" aria-hidden="true" />
              {this.props.content.back}
            </button>
          </div>
          <div className="col-sm-7 col-xs-7 text-right">
            <button
              className="btn-link white help-btn"
              onClick={this.modalClick}
            >
              <span
                className="icon icon-help-questions"
                aria-label="Click on Icon to get More Information"
              />
            </button>
            {AccountsStore.getStmtPreferenceFlag() && (
              <button
                className="btn-link white settings-btn"
                onClick={this.goToStatementPreferences}
              >
                <span className="icon icon-settings" aria-hidden="true" />
                {this.props.content.statementPreferences}
              </button>
            )}
          </div>
        </div>
        <div className="inner-wrapper statement-panel">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <h3 className="statement1 break-line">
                Show me my statement for
              </h3>
              <div className="fc-select">
                <Select
                  ref="selectDropDown"
                  name="select"
                  autoFocus
                  value={this.state.selectedMonth}
                  onChange={this.onMonthChange}
                >
                  {this.dropDownMonthCalculation()}
                </Select>
              </div>
              {interestRate !== null ? (
                <p dangerouslySetInnerHTML={{ __html: interestRateMessage }} />
              ) : (
                ''
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div className="banner-img">
                {!this.isCBYB() && <div className="hopper" />}
              </div>
            </div>
          </div>
        </div>

        <p className="back_to_head">
          <a href="javascript:void(0)" onClick={this.backToTop}>
            <span className="back-to-top-icon">
              <SvgIcon id="icon-up" width="24px" height="24px" />
            </span>
          </a>
        </p>
        <div className="footer-btn">
          <button
            type="button"
            className="btn btn-sm download-statement"
            onClick={this.props.printStatements}
          >
            Print or download statement
          </button>
        </div>
      </div>
    );
  }
}
DigitalStatementsHeader.propTypes = {
  accountId: PropTypes.string,
  content: PropTypes.object,
  helpModal: PropTypes.func,
  getStatementsForSelectedMonth: PropTypes.func,
  printStatements: PropTypes.func,
  firstDayFlag: PropTypes.bool,
};
export default DigitalStatementsHeader;
